import { useMemo } from 'react';
import { useAllSwapsFilterStore } from './useFilterStores';
import { toQueryObject } from '../helpers/allSwaps';

export const useQueryFromAllSwapsFilters = () => {
  const {
    startDate,
    endDate,
    swapStates,
    assetsFrom,
    assetsTo,
    swapTypes,
    brokers,
    refundAddress,
    destinationAddress,
    swapSizeRange,
  } = useAllSwapsFilterStore();

  const filters = {
    startDate,
    endDate,
    swapStates,
    assetsFrom,
    assetsTo,
    swapTypes,
    brokers,
    refundAddress,
    destinationAddress,
    swapSizeRange,
  };

  return useMemo(
    () => toQueryObject(filters),
    [
      startDate,
      endDate,
      swapStates,
      assetsFrom,
      assetsTo,
      swapTypes,
      brokers,
      refundAddress,
      destinationAddress,
      swapSizeRange,
    ],
  );
};
